import type { Company } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  company: Company;
}

export function useEditCompany() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ company }: Params) =>
      post({
        url: `/companies/${company.companyId}`,
        body: {
          name: company.name,
          status: company.status,
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies() });
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies('all') });
      queryClient.invalidateQueries({ queryKey: queryKeys.getCompanies('active') });
    },
  });

  const editCompany = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    editCompany,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
